import { type DesignSystemTextAreaProps } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import BaseTextArea from 'modules/core/components/TextArea'

export type TextAreaFieldProps = DesignSystemTextAreaProps & {
  field: Field
  onChange?: (field: Field) => void
}

const TextArea = ({
  mandatory,
  readonly,
  label,
  field,
  placeholder,
  secondaryLabel,
  onBlur,
  onChange,
  minRows = 3,
  loading = false,
}: TextAreaFieldProps) => {
  const error = field.isDirty ? null : field.errors && field.errors[0]

  function onChangeEvent(value: string) {
    field.set(value)
    onChange && onChange(field)
  }

  return (
    <BaseTextArea
      mandatory={mandatory}
      secondaryLabel={secondaryLabel}
      label={label}
      readonly={readonly}
      minRows={minRows}
      onChange={(value: string) => onChangeEvent(value)}
      onBlur={onBlur}
      placeholder={placeholder}
      value={field.value || ''}
      error={error || undefined}
      loading={loading}
    />
  )
}

export default observer(TextArea)
